import { render, staticRenderFns } from "./ForgottenPasswordEmailSentPage.vue?vue&type=template&id=2f457fe4&scoped=true&"
import script from "./ForgottenPasswordEmailSentPage.vue?vue&type=script&lang=ts&"
export * from "./ForgottenPasswordEmailSentPage.vue?vue&type=script&lang=ts&"
import style0 from "./ForgottenPasswordEmailSentPage.vue?vue&type=style&index=0&id=2f457fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f457fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
